/** @format */

import React from "react";
import { FaCheck } from "react-icons/fa";

const ValidityCheck = ({ className = "", rightClassName = "tw-right-2.5" }) => (
  <span
    aria-hidden="true"
    className={`tw-pointer-events-none tw-absolute tw-bottom-0 ${rightClassName} tw-top-0 tw-z-[2] tw-my-auto tw-flex tw-h-[18px] tw-w-[18px] tw-items-center tw-justify-center tw-rounded-full tw-bg-dis-success tw-text-white ${className}`}
  >
    <FaCheck className="tw-h-2.5 tw-w-2.5" />
  </span>
);

export default ValidityCheck;
